<script setup lang="ts">
import { type StateRoot } from './state'
import enums from '@/state-providers/enums'
import useBackend from "@/composition/useBackend";
import { provide, reactive, ref } from "vue";
import graphMeta from "@/state-providers/graph-meta";
import { Panel } from '@hantera/design-system';
import parseJson from "@/parse-json";
import { stateContextKey } from "@/keys";
import { Models } from "@hantera/portal-app";

const { fetch } = useBackend();
const error = ref<string>();

const loadResponse = await fetch('/load', {
  method: 'GET',
});

if (!loadResponse.ok) {
  error.value = `Unable to load configuration from server: (${loadResponse.status}) ${await loadResponse.text()}`;
} else {
  const state = reactive(parseJson(await loadResponse.text()) as StateRoot);

  provide(stateContextKey, state);
  const graphMetaComposable = graphMeta(state)
  provide('$portal_graphMeta', graphMetaComposable);
  provide('$portal_enums', enums(fetch, graphMetaComposable as Record<string, Models.GraphMeta.GraphNodeMeta>));
}

</script>

<template>
  <div v-if="error" class="state-error">
    <Panel label="Failed to load" class="state-error__panel">
      {{ error }}
    </Panel>
  </div>
  <slot v-else></slot>
</template>

<style scoped>
.state-error {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.state-error__panel {
  border-color: var(--color-error-50);
}
</style>